export default "__VITE_ASSET__5f0f84b2__"